module.exports = __webpack_public_path__ + "static/img/idea_bg.6874617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/idea_bg.png
// module id = 3zBF
// module chunks = 0